import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Observable, of } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { Teacher } from '../../../Elearning-Models';

@Component({
  selector: 'app-teacher-search-autofill',
  templateUrl: './teacher-search-autofill.component.html',
  styleUrls: ['./teacher-search-autofill.component.scss']
})
export class TeacherSearchAutofillComponent implements OnInit {
  teacherSearchControl = new FormControl();
  filteredTeachers: Observable<Teacher[]>;

  @Input() teachers: Teacher[];
  @Input() teacherid: number;
  @Output() teacher: EventEmitter<Teacher> = new EventEmitter<Teacher>();


  @ViewChild("autoTeacher") autoTeacher: ElementRef;

  ngOnInit() {
    if(this.teacherid){
      let teacher = this.teachers.find(t => t.UserID == this.teacherid);
      this.teacherSearchControl.setValue(teacher.FirstName + " " + teacher.LastName);
    }

    this.filteredTeachers = this.teacherSearchControl.valueChanges
    .pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: String): Teacher[] {
    const filterValue = value.toLowerCase();
    return this.teachers.filter(teacher => teacher.FirstName.toLowerCase().includes(filterValue) || teacher.LastName.toLowerCase().includes(filterValue));
  }

  selectTeacher(t: Teacher){
    this.teacher.emit(t);
    this.autoTeacher.nativeElement.value = t.FirstName + " " + t.LastName;
    //this.filteredTeachers = of(this.teachers);
    this.autoTeacher.nativeElement.blur();
  }
}
